import React from "react";
import './404.scss'


export class NotFound extends React.Component {
  render() {
    return (
      <>
      <div class="my404">
<div class="noise"></div>
<div class="overlay404"></div>
<div class="terminal404">
  <h1>Error <span class="errorcode">404</span></h1>
  <p class="output404">The page you are looking for might have been removed, had its name changed or is temporarily unavailable.</p>
  <p class="output404">Please try to <a class="a404link" href="#1">go back</a> or <a class="a404link" href="#2">return to the homepage</a>.</p>
  <p class="output404">Good luck.</p>
</div>
</div>
      </>
    );
  }
}